import { createFileRoute } from '@tanstack/react-router';

import PostLogin from 'component/view/Auth/PostLogin';

export const Route = createFileRoute('/post-login')({
  component: PostLogin,
});
